import React from 'react';

import SchemaCatalogShell from './SchemaCatalogShell';

/**
 * Onboarding components — the registry of onboarding step kinds.
 * Each row carries a `schema_json` describing the step's config
 * surface (copy, inputs, nav). Tenants pick + sequence these when
 * building an onboarding flow.
 *
 * R5 uses the raw Monaco editor; the structured 2-pane editor lands
 * in a later round (see ComponentTypes for the same note).
 */

const OnboardingComponents: React.FC = () => (
  <SchemaCatalogShell
    slug="onboarding-components"
    title="Onboarding components"
    breadcrumbLabel="Onboarding components"
    emptyBody="Onboarding components are the enumerated step kinds tenants can sequence into their onboarding flows. Each type's schema_json defines its config."
    addCtaLabel="Add first onboarding component"
    schemaHint="Each row's schema_json defines the step's config surface."
  />
);

export default OnboardingComponents;
